var _rect, _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCancelled = function SvgCancelled(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FFE0E4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9648 18.6758L21.8359 16.836C22.2031 16.4727 22.7969 16.4727 23.1289 16.836C23.5273 17.2032 23.5273 17.7969 23.1289 18.129L21.3242 19.9649L23.1289 21.836C23.5273 22.2032 23.5273 22.7969 23.1289 23.129C22.7969 23.5274 22.2031 23.5274 21.8359 23.129L19.9648 21.3243L18.1289 23.129C17.7969 23.5274 17.2031 23.5274 16.8359 23.129C16.4727 22.7969 16.4727 22.2032 16.8359 21.836L18.6758 19.9649L16.8359 18.129C16.4727 17.7969 16.4727 17.2032 16.8359 16.836C17.2031 16.4727 17.7969 16.4727 18.1289 16.836L19.9648 18.6758Z",
    fill: "#FF405B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10 20C10 14.4766 14.4766 10 20 10C25.5234 10 30 14.4766 30 20C30 25.5234 25.5234 30 20 30C14.4766 30 10 25.5234 10 20ZM16.8359 18.1289L18.6758 19.9648L16.8359 21.8359C16.4727 22.2031 16.4727 22.7969 16.8359 23.1289C17.2031 23.5273 17.7969 23.5273 18.1289 23.1289L19.9648 21.3242L21.8359 23.1289C22.2031 23.5273 22.7969 23.5273 23.1289 23.1289C23.5273 22.7969 23.5273 22.2031 23.1289 21.8359L21.3242 19.9648L23.1289 18.1289C23.5273 17.7969 23.5273 17.2031 23.1289 16.8359C22.7969 16.4727 22.2031 16.4727 21.8359 16.8359L19.9648 18.6758L18.1289 16.8359C17.7969 16.4727 17.2031 16.4727 16.8359 16.8359C16.4727 17.2031 16.4727 17.7969 16.8359 18.1289Z",
    fill: "#FF405B"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCancelled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cancelled.5d56ba91.svg";
export { ForwardRef as ReactComponent };